import { DefaultTemplate, DefaultTemplateProps } from './DefaultTemplate';

export const TikTokCampaignPostForm = ({
  postId,
  onClose,
  campaignId,
  campaignFinished
}: Pick<DefaultTemplateProps, 'campaignId' | 'postId' | 'onClose' | 'campaignFinished'>) => (
  <DefaultTemplate postId={postId} onClose={onClose} campaignFinished={campaignFinished} campaignId={campaignId} />
);
